import queryString from 'querystring-es3'
import { findByShort as findCountryLocationByShort } from './countryLocations'
import { findByName as findStateLocationByName } from './usStateLocations'

const getZoom = (location, zoomFallback) => {
  const search = queryString.parse(location.search)
  if (search.zoom) {
    return parseFloat(search.zoom) || zoomFallback
  }

  return zoomFallback
}

const getCenter = (location, country, state) => {
  const search = queryString.parse(location.search)
  if (search.center) {
    const latLng = search.center.split(',')
    return {
      lat: parseFloat(latLng[0]),
      lng: parseFloat(latLng[1]),
    }
  }

  if (state) {
    const latLng = findStateLocationByName(state.name)
    return {
      lat: latLng.latitude,
      lng: latLng.longitude,
    }
  }

  if (country) {
    const latLng = findCountryLocationByShort(country.short)
    return {
      lat: latLng.latitude,
      lng: latLng.longitude,
    }
  }

  return {
    lat: 0,
    lng: 0,
  }
}

export { getZoom, getCenter }
